// src/config/api.js
// API Configuration - Uses environment variable with fallback to production

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://clinhx-backend-v2.onrender.com/api';

export default API_BASE_URL;
